import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue } from "../../utils/filters";
import { IValidationResource } from "../../validations";

export interface IValidationQueryParameters {
    validation?: IValidationResource;
}

export type IValidationQueryResult = IValidationResource;

export const validationQuery: IApiQueryFunction<IValidationQueryParameters> = ({ validation }) => {
    if (!validation) {
        return;
    }

    return {
        method: "GET",
        url: `/validations/${mapRelationalValue(validation)}`,
    };
};

export const useValidationQuery = createApiQueryHook<IValidationQueryParameters, IValidationQueryResult>(
    validationQuery,
);
